import type { AxiosInstance } from 'axios';
import type { Organization } from '@/types';

export const listOrganizations = async (api: AxiosInstance): Promise<Organization[]> => {
  const resp = await api.get<Organization[]>('/accqsure/admin/org');
  return resp.data;
};

export const getOrganization = async (api: AxiosInstance, organization_id: string): Promise<Organization> => {
  const resp = await api.get<Organization>(`/accqsure/admin/org/${organization_id}`);
  return resp.data;
};

export type OrganizationCreateRequest = Pick<
  Organization,
  'name' | 'email' | 'customer_domain' | 'tenant_domain' | 'api_endpoint'
> &
  Partial<
    Pick<
      Organization,
      | 'on_prem'
      | 'auth_type'
      | 'authority'
      | 'client_id'
      | 'redirect_uri'
      | 'response_type'
      | 'scope'
      | 'post_logout_redirect_uri'
      | 'response_mode'
      | 'introspection_endpoint'
      | 'llm_endpoint'
      | 'llm_model_family'
      | 'vllm_endpoint'
      | 'vllm_model_family'
      | 'embedding_endpoint'
      | 'vdb_endpoint'
      | 'te_endpoint'
    >
  >;

export type OrganizationUpdateRequest = Partial<OrganizationCreateRequest>;

export const createOrganization = async (
  api: AxiosInstance,
  payload: OrganizationCreateRequest,
): Promise<Organization> => {
  const resp = await api.post<Organization>('/accqsure/admin/org', payload);
  return resp.data;
};

export const updateOrganization = async (
  api: AxiosInstance,
  organization_id: string,
  payload: OrganizationUpdateRequest,
): Promise<Organization> => {
  const resp = await api.put<Organization>(
    `/accqsure/admin/org/${organization_id}`,
    payload,
  );
  return resp.data;
};

export const deleteOrganization = async (
  api: AxiosInstance,
  organization_id: string,
): Promise<void> => {
  await api.delete(`/accqsure/admin/org/${organization_id}`);
};

